'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.isYesterday = exports.isTomorrow = exports.isDaysApart = exports.isToday = exports.isBetween = exports.convertToLocalDate = exports.TimeValue = exports.zeroPad = exports.duration = exports.isValidDate = exports.convertToDate = exports.convertToIsoDate = exports.fromIsoDate = exports.isoDate = exports.daysInMonth = void 0;
var strings_1 = require("./strings");
function daysInMonth(month, year) {
    switch (month) {
        case 2:
            return (year % 4 === 0 && year % 100) || year % 400 === 0 ? 29 : 28;
        case 4:
        case 6:
        case 9:
        case 11:
            return 30;
        default:
            return 31;
    }
}
exports.daysInMonth = daysInMonth;
var DATE_SEPARATOR = '-';
function isoDate(day, month, year) {
    return [year, strings_1.leftPad(month), strings_1.leftPad(day)].join(DATE_SEPARATOR);
}
exports.isoDate = isoDate;
function fromIsoDate(dateValue) {
    if (!dateValue) {
        return { day: '', month: '', year: '' };
    }
    var splitDate = dateValue.split(DATE_SEPARATOR);
    return {
        day: splitDate[2] || '',
        month: splitDate[1] || '',
        year: splitDate[0] || '',
    };
}
exports.fromIsoDate = fromIsoDate;
/**
 * Converts a date into a string representation
 * of that date.
 *
 * Format: YYYY-MM-DD
 * @param date The JS date to convert
 */
function convertToIsoDate(date) {
    var day = date.getDate().toString();
    var month = (date.getMonth() + 1).toString();
    var year = date.getFullYear().toString();
    return isoDate(day, month, year);
}
exports.convertToIsoDate = convertToIsoDate;
/**
 * Converts various date formats to a JS date.
 * Useful to accept component properties in any format.
 *
 * @param date date string or timestamp to convert to JS date
 */
function convertToDate(date) {
    if (typeof date === 'string' || typeof date === 'number') {
        return new Date(date);
    }
    return date;
}
exports.convertToDate = convertToDate;
/**
 * Checks if the passed through date is a valid date.
 * @param date The proposed date object
 */
function isValidDate(date) {
    return date instanceof Date && !isNaN(date.getTime());
}
exports.isValidDate = isValidDate;
/**
 * Takes the specified timestamp and outputs the
 * amount of days/hours/minutes/seconds the value
 * represents.
 * @param time The amount of time in milliseconds
 */
function duration(time) {
    var days = Math.floor(time / TimeValue.DAY);
    time = time % TimeValue.DAY;
    var hours = Math.floor(time / TimeValue.HOUR);
    time = time % TimeValue.HOUR;
    var minutes = Math.floor(time / TimeValue.MINUTE);
    time = time % TimeValue.MINUTE;
    var seconds = Math.floor(time / TimeValue.SECOND);
    return { days: days, hours: hours, minutes: minutes, seconds: seconds };
}
exports.duration = duration;
/**
 * Add zeros to pad any given values.
 * By default, it pads to 2 digits but the final string length can be defined
 * @param value the value to be padded
 * @param totalDigitCount total number of padded string
 */
var zeroPad = function (value, totalDigitCount) {
    if (totalDigitCount === void 0) { totalDigitCount = 2; }
    return String(value).padStart(totalDigitCount, '0');
};
exports.zeroPad = zeroPad;
/**
 * Time periods in milliseconds.
 */
var TimeValue;
(function (TimeValue) {
    TimeValue[TimeValue["DAY"] = 86400000] = "DAY";
    TimeValue[TimeValue["HOUR"] = 3600000] = "HOUR";
    TimeValue[TimeValue["MINUTE"] = 60000] = "MINUTE";
    TimeValue[TimeValue["SECOND"] = 1000] = "SECOND";
})(TimeValue = exports.TimeValue || (exports.TimeValue = {}));
/**
 * Converts any date to local date with timezone
 *
 * @param date date to convert to local timezone
 */
function convertToLocalDate(date) {
    return new Date(date.getTime() + date.getTimezoneOffset() * TimeValue.MINUTE);
}
exports.convertToLocalDate = convertToLocalDate;
/**
 * Checks if a date is between 2 other dates
 *
 * @param date date to check
 * @param from inferior limit date
 * @param to   superior limit date
 */
function isBetween(date, from, to) {
    return date >= from && date <= to;
}
exports.isBetween = isBetween;
/**
 * Checks whether the passed through date is today.
 * @param date date to compare to todays date
 */
function isToday(date) {
    return date.toDateString() === new Date().toDateString();
}
exports.isToday = isToday;
/**
 * Checks if a date is x days apart.
 *
 * @param date the date to check
 * @param days the number of days apart from given date
 */
var isDaysApart = function (date, days) {
    var futureDate = new Date();
    futureDate.setDate(futureDate.getDate() + days);
    return (futureDate.getFullYear() === date.getFullYear() &&
        futureDate.getMonth() === date.getMonth() &&
        futureDate.getDate() === date.getDate());
};
exports.isDaysApart = isDaysApart;
/**
 * Checks if a given date is the day after current day
 * @param date date to check
 */
var isTomorrow = function (date) { return exports.isDaysApart(date, 1); };
exports.isTomorrow = isTomorrow;
/**
 * Checks if a given date is the day before current day
 * @param date date to check
 */
var isYesterday = function (date) { return exports.isDaysApart(date, -1); };
exports.isYesterday = isYesterday;
